import React, { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';

const SoatRechargeModal = ({ isOpen, onClose, onSuccess }) => {
  const [soatData, setSoatData] = useState({ balance: 0, total_recharges: 0, total_discounts: 0, history: [] });
  const [rechargeAmount, setRechargeAmount] = useState('');
  const [rechargeDesc, setRechargeDesc] = useState('');
  const [recharging, setRecharging] = useState(false);
  const [soatSuccessMsg, setSoatSuccessMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setError('');
      setSoatSuccessMsg('');
      fetchSoatBalance();
    }
  }, [isOpen]);

  const fetchSoatBalance = async () => {
    try {
      const res = await axios.get('/api/tramites/soat-balance');
      setSoatData(res.data);
    } catch (err) {
      console.error('Error al obtener saldo SOAT:', err);
      setError('Error al consultar saldo de SOAT');
    }
  };

  const handleRecargar = async (e) => {
    e.preventDefault();
    if (!rechargeAmount || isNaN(rechargeAmount) || Number(rechargeAmount) <= 0) {
      alert('Ingrese un monto válido a recargar');
      return;
    }

    try {
      setRecharging(true);
      const res = await axios.post('/api/tramites/soat-recharge', {
        amount: Number(rechargeAmount),
        description: rechargeDesc
      });
      setSoatSuccessMsg(`✅ ${res.data.message}`);
      setRechargeAmount('');
      setRechargeDesc('');
      fetchSoatBalance();
      if (onSuccess) onSuccess();
      setTimeout(() => setSoatSuccessMsg(''), 4000);
    } catch (err) {
      alert(`❌ Error: ${err.response?.data?.message || err.message}`);
    } finally {
      setRecharging(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '650px', width: '100%' }}>
        <button className="btn-close" onClick={onClose}>
          &times;
        </button>
        <div className="modal-header">
          <h3>💰 Módulo de Saldo y Recargas SOAT</h3>
        </div>

        <div className="modal-body">
          {error && <div className="error-banner">{error}</div>}
          {soatSuccessMsg && (
            <div style={{ padding: '12px', background: '#dcfce7', color: '#15803d', borderRadius: '8px', marginBottom: '15px', fontWeight: 'bold' }}>
              {soatSuccessMsg}
            </div>
          )}

          {/* Cards Saldo Actual */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '20px' }}>
            <div style={{ background: '#eff6ff', padding: '15px', borderRadius: '10px', border: '1px solid #bfdbfe', textAlign: 'center' }}>
              <span style={{ fontSize: '11px', color: '#1e40af', fontWeight: '700', textTransform: 'uppercase' }}>Saldo Disponible</span>
              <div style={{ fontSize: '18px', fontWeight: '900', color: '#1d4ed8', marginTop: '4px' }}>
                ${Number(soatData.balance).toLocaleString('es-CO')}
              </div>
            </div>
            <div style={{ background: '#f0fdf4', padding: '15px', borderRadius: '10px', border: '1px solid #bbf7d0', textAlign: 'center' }}>
              <span style={{ fontSize: '11px', color: '#166534', fontWeight: '700', textTransform: 'uppercase' }}>Total Recargado</span>
              <div style={{ fontSize: '18px', fontWeight: '900', color: '#15803d', marginTop: '4px' }}>
                ${Number(soatData.total_recharges).toLocaleString('es-CO')}
              </div>
            </div>
            <div style={{ background: '#fef2f2', padding: '15px', borderRadius: '10px', border: '1px solid #fecaca', textAlign: 'center' }}>
              <span style={{ fontSize: '11px', color: '#991b1b', fontWeight: '700', textTransform: 'uppercase' }}>Total Descontado</span>
              <div style={{ fontSize: '18px', fontWeight: '900', color: '#b91c1c', marginTop: '4px' }}>
                ${Number(soatData.total_discounts).toLocaleString('es-CO')}
              </div>
            </div>
          </div>

          {/* Formulario de Recarga */}
          <form onSubmit={handleRecargar} style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' }}>
            <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#1e293b' }}>➕ Recargar Saldo SOAT</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: '10px', alignItems: 'flex-end' }}>
              <div>
                <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>Monto ($):</label>
                <input
                  type="number"
                  placeholder="Ej: 500000"
                  value={rechargeAmount}
                  onChange={(e) => setRechargeAmount(e.target.value)}
                  required
                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: '6px', fontSize: '13px' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>Descripción / Referencia:</label>
                <input
                  type="text"
                  placeholder="Ej: Recarga Nequi / Transferencia SOAT"
                  value={rechargeDesc}
                  onChange={(e) => setRechargeDesc(e.target.value)}
                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: '6px', fontSize: '13px' }}
                />
              </div>
              <button
                type="submit"
                disabled={recharging}
                style={{ padding: '9px 18px', background: '#16a34a', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '700', cursor: 'pointer' }}
              >
                {recharging ? '...' : 'Recargar'}
              </button>
            </div>
          </form>

          {/* Historial de Movimientos */}
          <div>
            <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#1e293b' }}>📜 Historial de Recargas y Descuentos</h4>
            <div style={{ maxHeight: '220px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                <thead>
                  <tr style={{ background: '#f1f5f9', textAlign: 'left', color: '#475569' }}>
                    <th style={{ padding: '8px' }}>Tipo</th>
                    <th style={{ padding: '8px' }}>Monto</th>
                    <th style={{ padding: '8px' }}>Descripción</th>
                    <th style={{ padding: '8px' }}>Usuario</th>
                    <th style={{ padding: '8px' }}>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {soatData.history && soatData.history.length > 0 ? (
                    soatData.history.map((item, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '8px' }}>
                          <span style={{
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            fontWeight: '700',
                            background: item.tipo === 'recarga' ? '#dcfce7' : '#fee2e2',
                            color: item.tipo === 'recarga' ? '#166534' : '#991b1b'
                          }}>
                            {item.tipo === 'recarga' ? '➕ RECARGA' : '➖ DESCUENTO'}
                          </span>
                        </td>
                        <td style={{ padding: '8px', fontWeight: 'bold', color: item.tipo === 'recarga' ? '#15803d' : '#b91c1c' }}>
                          ${Number(item.amount).toLocaleString('es-CO')}
                        </td>
                        <td style={{ padding: '8px' }}>{item.description || '—'}</td>
                        <td style={{ padding: '8px' }}>{item.usuario || 'Sistema'}</td>
                        <td style={{ padding: '8px', color: '#64748b' }}>{new Date(item.created_at).toLocaleString('es-CO')}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ padding: '15px', textAlign: 'center', color: '#64748b' }}>
                        No hay movimientos registrados.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <button className="btn-action" onClick={onClose} style={{ background: '#3b82f6', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', border: 'none', fontWeight: 'bold' }}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SoatRechargeModal;
